(() => {
  function prepareTrigger(trigger, pickerId) {
    if (!trigger) return;
    trigger.classList.add('zagara-booking-action');
    trigger.removeAttribute('target');
    trigger.removeAttribute('rel');
    trigger.setAttribute('aria-haspopup', 'dialog');
    if (pickerId) trigger.setAttribute('aria-controls', pickerId);
    trigger.setAttribute('aria-expanded', 'false');
  }

  function connectFooterBookingPicker(root = document) {
    const footer = root.querySelector?.('.zagara-footer') || document.querySelector('.zagara-footer');
    if (!footer) return;

    const picker = document.querySelector('[data-zagara-booking-picker]');
    const pickerId = picker?.id || '';

    footer.querySelectorAll('.zagara-footer__column ul a').forEach((link) => {
      if (link.textContent.trim() !== 'Prenota ora') return;
      prepareTrigger(link, pickerId);
    });

    prepareTrigger(footer.querySelector('.zagara-footer__cta-button'), pickerId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => connectFooterBookingPicker(), { once: true });
  } else {
    connectFooterBookingPicker();
  }

  window.setTimeout(() => connectFooterBookingPicker(), 400);
  document.addEventListener('shopify:section:load', (event) => {
    connectFooterBookingPicker(event.target || document);
  });
})();